module.exports = __webpack_public_path__ + "bcaa7124c03df2de82bd8aceb5df407a.MP3";